import { render, staticRenderFns } from "./OfferwallComplete.vue?vue&type=template&id=c5c0ab7e&scoped=true&lang=pug"
import script from "./OfferwallComplete.vue?vue&type=script&lang=js"
export * from "./OfferwallComplete.vue?vue&type=script&lang=js"
import style0 from "./OfferwallComplete.vue?vue&type=style&index=0&id=c5c0ab7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5c0ab7e",
  null
  
)

export default component.exports